export default 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M2 8a6 6 0 0 1 6-6v12a6 6 0 0 1-6-6';